import type { DimensionValue } from "react-native"

const PIXELS = {
  "$-1": -4,
  "$-2": -8,
  "$-3": -12,
  "$-4": -16,
  "$0": 0,
  "$0.5": 2,
  "$1": 4,
  "$1.5": 6,
  "$10": 40,
  "$12": 48,
  "$14": 56,
  "$16": 64,
  "$2": 8,
  "$2.5": 10,
  "$20": 80,
  "$24": 96,
  "$28": 112,
  "$3": 12,
  "$3.5": 14,
  "$32": 128,
  "$4": 16,
  "$40": 160,
  "$44": 176,
  "$48": 192,
  "$5": 20,
  "$56": 224,
  "$6": 24,
  "$64": 256,
  "$7": 28,
  "$72": 288,
  "$8": 32,
  "$80": 320,
  "$9": 36,
  "$96": 384,
}
export const SPACING = {
  ...PIXELS,
  "$1/2": "50%",
  "$1/3": "33.333%",
  "$1/4": "25%",
  "$1/5": "20%",
  "$1/6": "16.666%",
  "$2/3": "66.666%",
  "$2/4": "50%",
  "$2/5": "40%",
  "$2/6": "33.333%",
  "$3/4": "75%",
  "$3/5": "60%",
  "$3/6": "50%",
  "$4/5": "80%",
  "$4/6": "66.666%",
  "$5/6": "83.333%",
  "$full": "100%",
  "$minWidthMobile": 275,
  "$toolbar": 64,
  "10%": "10%",
  "100%": "100%",
  "20%": "20%",
  "25%": "25%",
  "30%": "30%",
  "33.333%": "33.333%",
  "40%": "40%",
  "50%": "50%",
  "60%": "60%",
  "66.666%": "66.666%",
  "70%": "70%",
  "75%": "75%",
  "80%": "80%",
  "83.333%": "83.333%",
  "90%": "90%",
  "95%": "95%",
  "auto": "auto",
} satisfies { [key: string]: DimensionValue }
export type SpaceToken = keyof typeof SPACING
